import { render } from "./BackgroundPartial.vue?vue&type=template&id=27671000&scoped=true"
import script from "./BackgroundPartial.vue?vue&type=script&lang=js"
export * from "./BackgroundPartial.vue?vue&type=script&lang=js"

import "./BackgroundPartial.vue?vue&type=style&index=0&id=27671000&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27671000"]])

export default __exports__